import { takeEvery, call, put, select, race, delay } from 'redux-saga/effects'
import { getTenderSteps } from '../../lib/requests/routesRequests'
import { delays } from '../../lib/constants'
import { getCurrentLang, getToken, getDicionary } from '../selectors'

export function* worker({ periodic }) {
  yield put({ type: 'SET_FLAG_FOR_BID_STEPS', payload: true })
  try {
    const currentLang = yield select(getCurrentLang)
    const token = yield select(getToken)
    const dic = yield select(getDicionary)

    const { result } = yield race({
      result: call(getTenderSteps, token, currentLang, periodic),
      timeout: delay(delays.forCancelRequest),
    })

    if (result && result.status === 200) {
      yield put({
        type: 'SET_BID_STEPS',
        payload: result.data.data.map((num) => ({
          ...{},
          id: num,
          union: num,
        })),
      })
      yield put({ type: 'SET_FLAG_FOR_BID_STEPS', payload: false })
    } else {
      yield put({ type: 'SET_FLAG_FOR_BID_STEPS', payload: false })
      yield put({
        type: 'SHOW_ERROR_API',
        code: 6,
        message: dic.msg_server_err || 'internal server error',
      })
    }
  } catch (e) {
    yield put({ type: 'SET_FLAG_FOR_BID_STEPS', payload: false })
    yield put({
      type: 'SHOW_ERROR_API',
      code: String(e.response.status).slice(0, 1),
      message: e.response ? e.response.data.message : e.message,
    })
    if (e.response && e.response.data.relogin) {
      yield put({ type: 'SAGA_LOGOUT' })
    }
  }
}

export default function* tenderForWidget() {
  yield takeEvery('SAGA_GET_TENDER_BID_STEPS', worker)
}
